import React from "react";
import AuthFormCard from "components/auth-form-card/AuthFormCard";
import AuthForm from "components/auth-form/AuthForm";
import ErrorModal from "modals/error-modal/ErrorModal";
import SuccessModal from "modals/success-modal/SuccessModal";
import LoadingModal from "modals/loading/LoadingModal";
import { useUpdatePassword } from "./useUpdatePassword";

/**
 * Voluntary password change, reached from the settings menu. Same AuthFormCard + AuthForm shell as
 * the login and forced-rotation pages.
 *
 * No "try again" on the error modal: the retry is the form itself, still filled in behind it, and
 * a modal-driven resubmit would spend one of the three attempts without the user choosing to.
 */
function UpdatePasswordForm() {
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    showSuccess,
    successMsg,
    handleSubmit,
    handleCloseError,
    handleCloseSuccess,
  } = useUpdatePassword();

  return (
    <>
      <AuthFormCard
        title="Update your password"
        subtitle="Confirm your current password, then choose a new one."
      >
        <AuthForm
          fields={fields}
          submitLabel="Update Password"
          onSubmit={handleSubmit}
          disabled={isSubmitDisabled}
          isLoading={showLoading}
          submitRef={submitRef}
        />
      </AuthFormCard>

      <LoadingModal isOpen={showLoading} loadingMsg={loadingMsg} />

      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
      />

      <SuccessModal
        isOpen={showSuccess}
        message={successMsg}
        handleClose={handleCloseSuccess}
      />
    </>
  );
}

export default UpdatePasswordForm;
